import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { useDropdown } from '@/hooks/useDropdown';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import useAssignDiscountCategory from './hooks/useAssignDiscountCategory';
import { useAttributes } from '@/hooks/useAttributes';

const assignDiscountFormSchema = z.object({
  location: z.string().min(1, { message: 'common.form.validation.required' }),
  club: z.string().min(1, { message: 'common.form.validation.required' }),
  newDiscountCategory: z.string().min(1, { message: 'common.form.validation.required' }),
});
export const AssignDiscountForm = () => {
  const form = useForm({ schema: assignDiscountFormSchema, mode: 'onBlur' });
  const { mutateAsync } = useAssignDiscountCategory();

  const locationValue = form.watch('location');
  const { data: locationOptions = [] } = useDropdown('Location');
  const { data: clubOptions = [] } = useAttributes('ClubByLocation', locationValue);
  const { data: newDiscountCategoryOptions = [] } = useDropdown('select_discount');
  const clubValue = form.watch('club');
  const { data: currentDiscountCategory = [{ label: '' }] } = useDropdown(
    'discountByClub',
    clubValue,
    undefined,
    undefined,
    !!clubValue,
  );
  const { t } = useDynamicLocale();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync({
          locationId: data.location,
          clubId: data.club,
          newDiscountCategoryId: data.newDiscountCategory,
        });
      }}
    >
      <div className="flex flex-col gap-4.5">
        <div>
          <Select
            label="configurationManagement.discountManagement.assignDiscount.location"
            {...form.register('location')}
            placeholder={t('configurationManagement.discountManagement.assignDiscount.locationPlaceholder')}
            options={locationOptions}
          />
        </div>
        <Select
          label="configurationManagement.discountManagement.assignDiscount.club"
          {...form.register('club')}
          disabled={!locationValue}
          options={clubOptions}
          placeholder={t('configurationManagement.discountManagement.assignDiscount.clubPlaceholder')}
        />
        <Input
          name="currentCommissionCharge"
          label="configurationManagement.discountManagement.assignDiscount.currentDiscount"
          forceRequired
          disabled
          value={currentDiscountCategory[0]?.label}
          placeholder={t('configurationManagement.discountManagement.assignDiscount.currentDiscountPlaceholder')}
        />
        <Select
          label="configurationManagement.discountManagement.assignDiscount.newDiscount"
          {...form.register('newDiscountCategory')}
          options={newDiscountCategoryOptions}
          placeholder={t('common.form.placeholder.select')}
        />
      </div>
    </Form>
  );
};
